<template>
  <v-card class="mx-4 my-6" id="group-screenshot-report" height="100%">
    <v-card-title class="py-0">
      <v-card-text class="text-h6 font-weight-medium pb-0 pl-0">
        SCREENSHOT REPORT
      </v-card-text>
    </v-card-title>
    <v-row class="mx-4">
      <v-col
        cols="8"
        class="d-flex align-center pa-0"
        id="group-send-screenshots"
      >
        Send Screenshots
      </v-col>
      <v-col cols="4" class="py-0 d-flex justify-end">
        <v-checkbox v-model="take_screenshots" />
      </v-col>
    </v-row>
    <v-row class="mx-4" id="group-screenshot-frequency">
      <v-select
        label="Frequency"
        filled
        dense
        :items="items"
        v-model="computedFrequency"
      />
    </v-row>
  </v-card>
</template>
<script>
import GroupDetailData from '@/mixins/GroupDetailData';

export default {
  mixins: [GroupDetailData],
  data() {
    return {
      items: ['1 min', '5 min', '30 min', '60 min', '180 min'],
    };
  },
  computed: {
    computedFrequency: {
      get() {
        return this.details.tablet_settings
          && this.details.tablet_settings.screenshot_frequency
          ? `${this.details.tablet_settings.screenshot_frequency.toString()
          } min`
          : '';
      },
      set(val) {
        this.details.tablet_settings.screenshot_frequency = parseInt(
          val.replace(/^\D+/g, ''),
        );
      },
    },
    take_screenshots: {
      get() {
        return this.details.tablet_settings
          ? this.details.tablet_settings.take_screenshots
          : '';
      },
      set(val) {
        this.details.tablet_settings.take_screenshots = val;
      },
    },
  },
};
</script>
